import { useEffect, useState } from "react";
import axiosInstance from "src/common/axiosInstance";
import { clearPipelines } from "../CachedData";
import LeadTableDesigner from "./LeadTableDesigner";
import { blueprintFromStarters, validateBlueprint } from "./tableBlueprint";

export default function PipelineSchemaSettings({ pipelines, pipelineId, onPipelineChange, onSaved, workspaceId, hidePicker = false }) {
  const pipeline = pipelines.find((item) => item.id === pipelineId);
  const [value, setValue] = useState(undefined);
  const [tableReady, setTableReady] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => { setValue(pipeline?.lead_schema ? blueprintFromStarters(pipeline.lead_schema) : undefined); }, [pipeline]);
  useEffect(() => { setMessage(""); }, [pipelineId]);
  const save = async () => {
    setSaving(true); setMessage("");
    try {
      validateBlueprint(value);
      await axiosInstance.post(`/workspaces/${workspaceId}/lead-fields/schema`, { pipeline_id: pipelineId, schema: value });
      clearPipelines(); await onSaved(); setMessage("Pipeline columns saved. Existing lead values are unchanged.");
    } catch (error) {
      setMessage(error?.response?.data?.message || error.message || "Unable to save pipeline columns.");
    } finally { setSaving(false); }
  };
  return <section className="ws-card crm-schema-card ws-rise" aria-label="Pipeline columns">
    <div className="crm-fields-head">
      <div className="ws-grow">
        <h2 className="ws-h3">{pipeline ? `Columns for ${pipeline.name}` : "Pipeline columns"}</h2>
        <p className="ws-muted">{pipeline ? "Sections group information in the lead form; fields become columns. Build them by hand, from a lead spreadsheet or from JSON." : "Choose a pipeline to design its table. Workspace-wide custom fields are listed below."}</p>
      </div>
      {!hidePicker && <label className="crm-schema-picker">Configure pipeline<select aria-label="Configure pipeline" value={pipelineId} onChange={(event) => onPipelineChange(event.target.value)} disabled={saving}><option value="">All custom fields</option>{pipelines.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}</select></label>}
    </div>
    {pipeline ? <div className="crm-schema-body">
      <LeadTableDesigner hideIntro onReadyChange={setTableReady} key={pipelineId} value={value} onChange={setValue} disabled={saving} />
      <div className="crm-schema-foot">
        {message ? <p role="status" className="ws-muted ws-grow">{message}</p> : <p className="ws-muted ws-grow">Existing custom fields stay as they are; edit or archive them below.</p>}
        <button type="button" disabled={saving || !tableReady || value === undefined} onClick={save} className="ws-btn ws-btn--primary">{saving ? "Saving…" : "Save pipeline columns"}</button>
      </div>
    </div> : message && <p role="status" className="ws-muted crm-schema-body">{message}</p>}
  </section>;
}
